interface AppleIMessageIconProps {
  className?: string;
  size?: number;
}

export const AppleIMessageIcon = ({
  className,
  size = 32,
}: AppleIMessageIconProps) => {
  return (
    <div>
      <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0" y="0" width="100" height="100" rx="22" fill="#34C759" />
        <path
          d="M50 20C29.85 20 14 33.36 14 49.5C14 58.97 19.46 67.4 28.29 72.76C27.44 79.67 23.95 85.94 23.91 86.01C23.64 86.48 23.62 87.06 23.86 87.55C24.11 88.03 24.58 88.37 25.12 88.45C25.45 88.5 25.78 88.49 26.08 88.41C35.06 86.08 42.09 82.15 45.22 80.27C46.79 80.44 48.38 80.53 50 80.53C70.15 80.53 86 67.17 86 51.03C86 34.89 70.15 20 50 20Z"
          fill="white"
        />
        <path d="M38 87L39.83 74.5L50.5 79L38 87Z" fill="white" />
      </svg>
    </div>
  );
};
